module.exports = __webpack_public_path__ + "static/media/get-pocket.82084c92.svg";